module.exports = __webpack_public_path__ + "static/media/ethereum.7b94eb61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/ethereum.svg
// module id = 852
// module chunks = 7